// @ts-ignore
import pdfMake from 'pdfmake/build/pdfmake';
// @ts-ignore
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function exportToPDF(data: any[], fileTitle: string) {
  const headers = data[0];
  const body = data.slice(1);

  const formattedBody = body.map((row) => {
    return row.map((cell) => {
      return { text: cell, style: 'tableRow' };
    });
  });

  const docDefinition = {
    content: [
      { text: fileTitle, style: 'header' },
      {
        table: {
          headerRows: 1,
          widths: headers.map(() => '*'), // Добавьте это значение для настройки ширины колонок
          body: [
            headers.map((header) => {
              return { text: header, style: 'tableHeader' };
            }),
            ...formattedBody,
          ],
        },
        layout: 'noBorders',
      },
    ],
    styles: {
      header: {
        fontSize: 16,
        bold: true,
      },
      tableHeader: {
        bold: true,
        fontSize: 15,
        color: 'black',
        margin: [0, 0, 10, 0],
      },
      tableRow: {
        fontSize: 14,
      },
      layout: 'noBorders',
    },
  };

  // @ts-ignore
  pdfMake.createPdf(docDefinition).download(`${fileTitle}.pdf`);
}
